import React from 'react';

function Contact() {
  return (
    <div className="tab-content">
      <h2>Contact & Legal Desk</h2>

      <div style={{ marginBottom: '30px' }}>
        <p style={{ fontSize: '16px', lineHeight: '1.8', marginBottom: '15px' }}>
          Need assistance? Our dedicated team is here to help you with legal matters,
          disputes, complaints, and general inquiries. We provide support to both students
          and service providers.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '25px', marginBottom: '40px' }}>
        <div style={{ padding: '20px', backgroundColor: '#e8f8f5', borderRadius: '8px', border: '2px solid #27ae60' }}>
          <h3 style={{ color: '#27ae60', marginBottom: '15px' }}>📧 Email Support</h3>
          <p style={{ fontSize: '14px', marginBottom: '8px' }}>
            <strong>Support Email:</strong><br />
            Support@globalresearchorganisation.com
          </p>
          <p style={{ fontSize: '14px' }}>
            <strong>Response Time:</strong> 24-48 hours
          </p>
        </div>

        <div style={{ padding: '20px', backgroundColor: '#ebf5fb', borderRadius: '8px', border: '2px solid #2980b9' }}>
          <h3 style={{ color: '#2980b9', marginBottom: '15px' }}>📞 Phone Support</h3>
          <p style={{ fontSize: '14px', marginBottom: '8px' }}>
            <strong>Helpline:</strong><br />
            +91 85954 63886
          </p>
          <p style={{ fontSize: '14px' }}>
            <strong>Hours:</strong> Mon-Fri, 9 AM - 6 PM IST
          </p>
        </div>

        <div style={{ padding: '20px', backgroundColor: '#fef5e7', borderRadius: '8px', border: '2px solid #f39c12' }}>
          <h3 style={{ color: '#f39c12', marginBottom: '15px' }}>🏢 Office Address</h3>
          <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
            GLOBAL RESEARCH ORGANISATION<br />
            10A/180 Vasundhara<br />
            Ghaziabad, Uttar Pradesh<br />
            India
          </p>
        </div>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Legal Assistance Services
        </h3>
        <div style={{ display: 'grid', gap: '15px' }}>
          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px' }}>
            <h4 style={{ color: '#27ae60', marginBottom: '8px' }}>⚖️ Dispute Resolution</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Mediation services for disputes between students and service providers
            </p>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px' }}>
            <h4 style={{ color: '#2980b9', marginBottom: '8px' }}>💼 Contract Review</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Free review of service agreements and contracts
            </p>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px' }}>
            <h4 style={{ color: '#e74c3c', marginBottom: '8px' }}>🛡️ Fraud Investigation</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Investigation and legal action against fraudulent providers
            </p>
          </div>

          <div style={{ padding: '15px', backgroundColor: '#ecf0f1', borderRadius: '8px' }}>
            <h4 style={{ color: '#f39c12', marginBottom: '8px' }}>💰 Refund Claims</h4>
            <p style={{ fontSize: '14px', lineHeight: '1.6', color: '#555' }}>
              Assistance in recovering payments from unethical service providers
            </p>
          </div>
        </div>
      </div>

      <div style={{
        backgroundColor: '#e74c3c',
        color: 'white',
        padding: '20px',
        borderRadius: '8px',
        marginTop: '30px'
      }}>
        <h4 style={{ marginBottom: '10px' }}>🚨 Emergency Support</h4>
        <p style={{ fontSize: '14px', lineHeight: '1.6' }}>
          For urgent legal matters or active fraud cases, please call our helpline:
          <strong style={{ display: 'block', fontSize: '18px', marginTop: '8px' }}>+91 85954 63886</strong>
        </p>
      </div>
    </div>
  );
}

export default Contact;
